import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  IMAGE_ELEMENT: `${cleanedFilename(__filename)}-image-element`,
  RESIZABLE: `${cleanedFilename(__filename)}-resizable`,
};
